import { ReactNode } from 'react'

const EventSettingsRow = ({ col1, col2 }: { col1: ReactNode; col2: ReactNode }) => {
  return (
    <div
      className="event-settings-row"
      style={{ display: 'flex', padding: '16px 20px', fontSize: '12px', flexWrap: 'wrap' }}
    >
      <div style={{ width: '300px', fontWeight: 'bold', display: 'flex', alignItems: 'center' }}>
        {col1}
      </div>
      <div style={{ width: 'auto', minWidth: '200px', display: 'flex', alignItems: 'center' }}>
        {col2}
      </div>
    </div>
  )
}

export default EventSettingsRow
